import React, { Component } from 'react'
import { Form, Col, Button, Container } from 'react-bootstrap';
import swal from 'sweetalert';


export default class SubInput extends Component {

    constructor(props) {

        super(props);
        this.state = {
            email: ''
        };

        

    }


    subscribe(event) {
        
        let email = document.getElementById("subscriber");
        
        if (email.value === '' || email.value === undefined) {
            
            swal(
                "Error",
                "",
                "error"
            );

        } else {
            swal(
                "Subscribed",
                "",
                "success"
            ).then(() => {
                email.value = "";
            });
        }
        
        event.preventDefault();

    }



    render() {


        return (


            <Container className="rounded-pill" style={{ backgroundColor: "" }}>

                <Form onSubmit={ this.subscribe }>

                    <Form.Row className="align-items-center">

                        <Col sm="7">
                            <Form.Control id="subscriber" className="" type="email" placeholder="email@example.com" />
                        </Col>
                        
                        <Col xs="auto" className="">
                            <Button className="buttonInside" style={{ backgroundColor: '#156fa1' }} variant="" type="submit">
                                <font color='white'>Subscribe</font>
                            </Button>
                        </Col>

                        

                    </Form.Row>

                </Form>
                
            </Container>


        );
    }


}

